var $analytics = {
  // ======================================================================
  // OPTIONS
  // ======================================================================

  use: true,
  type: 'gtag',

  // ======================================================================
  // GOOGLE
  // ======================================================================

  google: {
    // PAGE
    page: function(page, title) {
      console.log('%c••• analytics - google - page - ' + page + ' •••', 'color:#ccc;');
      if ($analytics.use == true) {
        // validate vars
        if (typeof page === 'undefined') return false;
        if (page[0] == '/') page = page.substr(1);
        // submit
        if ($analytics.type == 'gtag') {
          var data = {page_path: '/' + page};
          if (typeof title !== 'undefined') {
            data.page_title = title;
          }
          gtag('config', googleAnalyticsId, data);
        } else {
          ga('send', 'pageview', '/' + page);
        }
      }
    }
    // EVENT
    // event: function(category, action, label, value) {
    //   console.log('%c••• analytics - google - event - ' + category + ' - ' + action + ' •••', 'color:#ccc;');
    //   if ($analytics.use == true) {
    //     // validate vars
    //     if (typeof category === 'undefined') category = '';
    //     if (typeof action === 'undefined') action = '';
    //     if (typeof label === 'undefined') label = '';
    //     if (typeof value === 'undefined') value = '';
    //     // submit
    //     ga('send', 'event', category, action, label, value);
    //   }
    // }
  }
};
